"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gallo-matese": {
    "fba62fc8": [{
      "hkey": "5f933673",
      "slug": "gallo-matese",
      "name": "Gallo Matese",
      "primary": true,
      "skipSearch": false
    }],
    "acqua-spuzzata": [{
      "hkey": "5f933673",
      "slug": "gallo-matese",
      "name": "Gallo Matese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;